interface ThreeDotsProps {
  visible?: boolean;
  height?: string | number;
  width?: string | number;
  color?: string;
  radius?: string | number;
  ariaLabel?: string;
}

const ThreeDotsLoader = ({
  visible = true,
  height = 8,
  width = 8,
  color = "currentColor",
  radius = "50%",
  ariaLabel = "loading",
}: ThreeDotsProps) => {
  if (!visible) return null;
  const dotStyle = {
    width: typeof width === "number" ? `${width}px` : width,
    height: typeof height === "number" ? `${height}px` : height,
    backgroundColor: color,
    borderRadius: typeof radius === "number" ? `${radius}px` : radius,
  };
  return (
    <>
      <div role="status" aria-label={ariaLabel} className="flex items-center justify-center space-x-2">
        <span style={dotStyle} className="animate-three-dots delay-0"></span>
        <span style={dotStyle} className="animate-three-dots delay-200"></span>
        <span style={dotStyle} className="animate-three-dots delay-400"></span>
      </div>
      <style>{`
        @keyframes three-dots {
          0%, 80%, 100% {
            transform: scale(0.5);
          }
          40% {
            transform: scale(1.5);
          }
        }
        .animate-three-dots {
          animation: three-dots 0.8s infinite ease-in-out both;
        }
        .delay-0 {
          animation-delay: 0s;
        }
        .delay-200 {
          animation-delay: 0.2s;
        }
        .delay-400 {
          animation-delay: 0.4s;
        }
      `}</style>
    </>
  );
};

export default ThreeDotsLoader;
